import ListaCondensadores from "./ListaCondensadores";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function CondensadorForm({ styles }) {
    return(
        <AlertDialogOnClose nome={"Condensador"} placeholder={"Insira o nome do condensador"}>
            <ListaCondensadores />
        </AlertDialogOnClose>
    )
} 